export const findAssetInBuildingsOrAssets = (
  locations,
  buildings,
  assets,
  itemId,
) => {
  return (
    locations
      .concat(buildings)
      .concat(assets)
      .find(item => item.properties.id === itemId)?.properties ||
    buildings
      .flatMap(item => item.properties.floors)
      .find(item => item.id === itemId) ||
    buildings
      .flatMap(item => item.properties.floors)
      .flatMap(item => item.zones)
      .find(item => item.id === itemId) ||
    buildings
      .flatMap(item => item.properties.floors)
      .flatMap(item => item.zones)
      .flatMap(item => item.assets)
      .find(item => item.id === itemId)
  );
};

export const findPropertyInBuildingsOrAssets = (
  property,
  buildings,
  assets,
  itemId,
) => {
  return (
    assets
      .flatMap(item => item.properties[property])
      .find(item => item.id === itemId) ||
    buildings
      .flatMap(item => item.properties.floors)
      .flatMap(item => item.zones)
      .flatMap(item => item.assets)
      .flatMap(item => item[property])
      .find(item => item.id === itemId)
  );
};

export const findSensorInBuildingsOrAssets = (buildings, assets, itemId) => {
  return findPropertyInBuildingsOrAssets('sensors', buildings, assets, itemId);
};

export const findActuatorInBuildingsOrAssets = (buildings, assets, itemId) => {
  return findPropertyInBuildingsOrAssets(
    'actuators',
    buildings,
    assets,
    itemId,
  );
};

export const findItemWithId = (sensors, itemId) => {
  return sensors.find(item => item.id === itemId);
};

export const filterSensorsForActuator = (sensors, actuatorId) => {
  return sensors.filter(item => item.id.split('|')[0] === actuatorId);
};

export const findKeyList = (item, key) => {
  switch (item?.type) {
    case 'BLD':
      return (
        item?.floors
          ?.flatMap(i => i.zones)
          ?.flatMap(i => i.assets)
          ?.flatMap(i => i[key]) || []
      );
    case 'FLR':
      return item?.zones?.flatMap(i => i.assets)?.flatMap(i => i[key]) || [];
    case 'ZON':
      return item?.assets?.flatMap(i => i[key]) || [];
    default:
      return item?.[key] || [];
  }
};

export const findKeyTypeList = (list, key) => {
  return (
    list?.reduce((unique, item) => {
      const val = item[key];
      if (!unique.some(u => u.value === val)) {
        unique.push({
          value: val,
          label: item[`${key}_name`],
        });
      }
      return unique;
    }, []) ?? []
  );
};

export const findABuilding = (buildings, asset) => {
  if (asset.type === 'BLD') {
    return asset;
  }

  if (asset.type === 'FLR') {
    return buildings.find(building =>
      building.properties.floors.some(floor => floor.id === asset.id),
    );
  }

  if (asset.type === 'ZON') {
    return buildings.find(building =>
      building.properties.floors.some(floor =>
        floor.zones.some(zone => zone.id === asset.id),
      ),
    );
  }

  return null;
};

export const findAFloor = (floors, id) => {
  const hasFloor = floors?.find(f => f.id === id);

  if (hasFloor) {
    return hasFloor;
  }

  return floors?.find(floor => floor.zones.some(zone => zone.id === id));
};

export const findBuildingAndFloorFromZone = (buildings, zoneId) => {
  const foundBuilding = buildings.find(building =>
    building.properties.floors.some(floor =>
      floor.zones.some(zone => zone.id === zoneId),
    ),
  );

  if (foundBuilding) {
    const foundFloor = foundBuilding.properties.floors.find(floor =>
      floor.zones.some(zone => zone.id === zoneId),
    );
    return [foundBuilding.properties.id, foundFloor.id];
  }
  return ['', ''];
};
